// @ts-nocheck
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { changePassword } from '../api/changePassword'
import { useState } from 'react'
import { useToast } from '@shared/toast/ToastProvider'
import { FormField } from '@shared/ui/FormField'
import { Input } from '@shared/ui/Input'
import { Button } from '@shared/ui/Button'

const schema = z.object({
  current_password: z.string().min(8),
  new_password: z.string().min(10)
})
type FormValues = z.infer<typeof schema>

export function ChangePasswordPage() {
  const [msg, setMsg] = useState<string | null>(null)
  const [err, setErr] = useState<string | null>(null)
  const { register, handleSubmit, formState } = useForm<FormValues>({ resolver: zodResolver(schema) })
  const { push } = useToast()

  const onSubmit = async (v: FormValues) => {
    setMsg(null)
    setErr(null)
    try {
      await changePassword(v)
      setMsg('Password changed successfully')
    } catch (e: any) {
      const m = e?.response?.data?.detail ?? 'Could not change password'
      setErr(m)
      push({ type: 'error', title: 'Change failed', description: m })
    }
  }

  return (
    <div className="max-w-md">
      <h1 className="text-xl font-semibold mb-4">Change password</h1>
      {msg && <div className="mb-2 text-sm text-success">{msg}</div>}
      {err && <div className="mb-2 text-sm text-danger">{err}</div>}
      <form className="grid gap-3" onSubmit={handleSubmit(onSubmit)}>
        <FormField label="Current password" message={formState.errors.current_password?.message}>
          <Input type="password" {...register('current_password')} />
        </FormField>
        <FormField label="New password" message={formState.errors.new_password?.message}>
          <Input type="password" {...register('new_password')} />
        </FormField>
        <Button disabled={formState.isSubmitting}>Change password</Button>
      </form>
    </div>
  )
}
// @ts-nocheck
